export class HotelSearch {
  params = {
    SessionId: "",
    CheckIn: "2020-12-09",
    CheckOut: "2020-12-24",
    Rooms: [],
    Destination: "Dubai (DXB), UAE",
  };
}
